import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const currentUser = authService.currentUser();

  // Always set withCredentials: true
  let clonedRequest = req.clone({
    withCredentials: true
  });

  // Only add Authorization header if not login URL and user is logged in
  if (!req.url.includes('/auth/v2/login') && currentUser?.accessToken) {
    clonedRequest = req.clone({
      withCredentials: true,
      setHeaders: {
        Authorization: `Bearer ${currentUser.accessToken}`
      }
    });
  }

  return next(clonedRequest);
};
